import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
    DATA_GRID_SX,
    DATA_GRID_SLOT_PROPS,
    DATA_GRID_LOCALE_TEXT,
    DATA_GRID_INITIAL_STATE,
    DATA_GRID_PAGE_SIZE_OPTIONS,
} from "../../../../components/ui/dataGridStyles";

/**
 * DataGrid de usuarios en escritorio (username, email, rol, estado y
 * acciones; columnas definidas en helpers/columns.js). Extraído de
 * ListaUsuarios (TASK-011) para que la página se mantenga como un
 * orquestador por debajo de 250 líneas, igual que UsuariosMobileList
 * concentra la vista de tarjetas.
 */
const UsuariosDataGrid = ({ rows, columns, loading }) => (
    <DataGrid
        rows={rows}
        columns={columns}
        localeText={DATA_GRID_LOCALE_TEXT}
        autoHeight
        loading={loading}
        disableRowSelectionOnClick
        initialState={DATA_GRID_INITIAL_STATE}
        pageSizeOptions={DATA_GRID_PAGE_SIZE_OPTIONS}
        slotProps={DATA_GRID_SLOT_PROPS}
        sx={DATA_GRID_SX}
    />
);

export default UsuariosDataGrid;
